import { render, staticRenderFns } from "./communityinitiali.vue?vue&type=template&id=3f5132e2&"
import script from "./communityinitiali.vue?vue&type=script&lang=js&"
export * from "./communityinitiali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports